import { render, staticRenderFns } from "./BarraLeft.vue?vue&type=template&id=6861c580&scoped=true&"
import script from "./BarraLeft.vue?vue&type=script&lang=js&"
export * from "./BarraLeft.vue?vue&type=script&lang=js&"
import style0 from "./BarraLeft.vue?vue&type=style&index=0&id=6861c580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6861c580",
  null
  
)

export default component.exports